<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de Citas</h5>

    <div style="display:flex; justify-content:space-between; align-items:center;
                background-color:#f0f0f0; padding:10px; border-radius:5px;">
      <h4 class="mb-0">Paso 1: Datos de la persona</h4>
      <div class="d-flex align-items-center gap-3">
        <span class="fw-semibold text-secondary" style="font-size:0.9rem;">Tipo de ingreso:</span>
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio" id="tipoAgendamiento"
                 value="Agendamiento" v-model="tipoIngreso">
          <label class="form-check-label" for="tipoAgendamiento">Agendamiento</label>
        </div>
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio" id="tipoAdmision"
                 value="Admisión" v-model="tipoIngreso">
          <label class="form-check-label" for="tipoAdmision">Admisión</label>
        </div>
      </div>
    </div>

    <hr>

    <div class="wizard-wrapper">
      <div class="wizard-body">
        <div class="row">

          <div class="col-md-3 d-flex align-items-start justify-content-center pt-3">
            <img src="../../assets/images/wizardCita/paciente_cita_01.png"
                 alt="Imagen" :style="estiloImagen" />
          </div>

          <div class="col-md-9">

            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="col-form-label">IdPersona</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled>
                </div>
              </div>
            </div>

            <!-- Tipo Id. / Documento -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Tipo Id.</label></div>
                <div class="col-4">
                  <select class="form-select" v-model="datoPersona.idTipoIden">
                    <option v-for="t in tiposIden" :key="t.idTipoIden" :value="t.idTipoIden">{{ t.nombre }}</option>
                  </select>
                </div>
                <div class="col-2"><label class="col-form-label">Documento</label></div>
                <div class="col-3">
                  <input type="text" class="form-control" v-model="datoPersona.documento"
                         style="text-transform:uppercase" @keyup.enter="consultarRC">
                </div>
                <div class="col-1">
                  <button type="button" class="btn btn-primary" @click="consultarRC" title="Buscar">
                    <i class="material-icons" style="font-size:20px;color:white;">search</i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Pri. Nombre / Seg. Nombre -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Pri. Nombre</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.primerNombre" style="text-transform:uppercase">
                </div>
                <div class="col-2"><label class="col-form-label">Seg. Nombre</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.segundoNombre" style="text-transform:uppercase">
                </div>
              </div>
            </div>

            <!-- Pri. Apellido / Seg. Apellido -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Pri. Apellido</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.primerApellido" style="text-transform:uppercase">
                </div>
                <div class="col-2"><label class="col-form-label">Seg. Apellido</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.segundoApellido" style="text-transform:uppercase">
                </div>
              </div>
            </div>

            <!-- Fecha Nac. / Sexo -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Fecha Nac.</label></div>
                <div class="col-4">
                  <input type="date" class="form-control" v-model="formattedFechaNac" :max="maxDate">
                </div>
                <div class="col-2"><label class="col-form-label">Sexo</label></div>
                <div class="col-4">
                  <select class="form-select" v-model="datoPersona.sexo">
                    <option value="F">Femenino</option>
                    <option value="M">Masculino</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Tipo Sangre / Estado Civil -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Tipo Sangre</label></div>
                <div class="col-4">
                  <select class="form-select" v-model="datoPersona.idTipoSangre">
                    <option v-for="t in tiposSangre" :key="t.idTipoSangre" :value="t.idTipoSangre">{{ t.nombre }}</option>
                  </select>
                </div>
                <div class="col-2"><label class="col-form-label">Estado Civil</label></div>
                <div class="col-4">
                  <select class="form-select" v-model="datoPersona.idEstadoCivil">
                    <option v-for="e in estadosCiviles" :key="e.idEstadoCivil" :value="e.idEstadoCivil">{{ e.nombre }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Teléfono -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Teléfono</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.telefono">
                </div>
              </div>
            </div>

            <!-- Localidad -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Localidad</label></div>
                <div class="col-10">
                  <div style="position: relative;">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchText"
                      placeholder="Escriba para buscar..."
                      @input="onSearchLocalidad"
                      @focus="mostrarDropdownLocalidad = true"
                      @blur="ocultarDropdownLocalidad"
                      style="text-transform: uppercase"
                      autocomplete="off"
                    />
                    <span v-if="buscandoLocalidad"
                          class="position-absolute top-50 end-0 translate-middle-y pe-2 text-muted">
                      <span class="spinner-border spinner-border-sm"></span>
                    </span>
                    <ul v-if="mostrarDropdownLocalidad && filteredLocalidades.length > 0"
                        class="localidad-dropdown">
                      <li v-for="loc in filteredLocalidades" :key="loc.idLocalidad"
                          @mousedown="selectLocalidad(loc)"
                          class="localidad-option">
                        <span class="loc-nombre">{{ loc.nombre }}</span>
                        <span class="loc-contexto">{{ contexto(loc.nombreJerarquico) }}</span>
                      </li>
                    </ul>
                    <div v-if="mostrarDropdownLocalidad && searchText.length >= 2
                               && filteredLocalidades.length === 0 && !buscandoLocalidad"
                         class="localidad-dropdown localidad-sin-resultado">
                      Sin resultados para "{{ searchText }}"
                    </div>
                  </div>
                  <small v-if="localidadHint" class="text-muted d-flex align-items-center gap-1 mt-1">
                    <i class="material-icons" style="font-size: 12px;">place</i>
                    {{ localidadHint.split(' -> ').join(' › ') }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Dirección -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">Dirección</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.direccion" style="text-transform:uppercase">
                </div>
              </div>
            </div>

            <!-- E-mail -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="col-form-label">E-mail</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.email">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="wizard-footer">
        <button v-if="btnCrear" type="button"
                class="btn btn-primary d-flex align-items-center gap-1"
                @click="guardarPersona">
          Siguiente
          <span class="material-symbols-outlined" style="font-size:24px;">chevron_right</span>
        </button>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout     from '@/components/Layout.vue'
import Footer     from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js'
import { validarPersona } from '@/modules/validarPersona.js'
import api        from '@/services/api'
import { alertaError } from '@/utils/alertas'

export default {
  props: {
  p_idPersona: { type: Number, required: true },
  },
  components: { Layout, Footer },
  data() {
    return {
      datoPersona:             {},
      tipoIngreso:             'Agendamiento',
      btnCrear:                true,
      btnEditar:               false,
      tiposIden:               [],
      estadosCiviles:          [],
      tiposSangre:             [],
      searchText:              '',
      localidadHint:           '',
      filteredLocalidades:     [],
      mostrarDropdownLocalidad:false,
      buscandoLocalidad:       false,
      debounceTimerLocalidad:  null,
      maxDate:                 new Date().toISOString().substr(0, 10),
      estiloImagen:            { width: '200px', height: '200px' },
    }
  },
  computed: {
    formattedFechaNac: {
      get() {
        if (!this.datoPersona.fechaNac) return ''
        const date  = new Date(this.datoPersona.fechaNac)
        const year  = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day   = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      set(value) {
        const date = new Date(value)
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
        this.datoPersona.fechaNac = date.toISOString()
      },
    },
  },
  mounted() {
    if (this.p_idPersona > 0) this.getData()
    const tipoGuardado = window.sessionStorage.getItem('tipoIngreso')
    if (tipoGuardado) this.tipoIngreso = tipoGuardado
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchTiposIden()
    this.fetchEstadosCiviles()
    this.fetchTiposSangre()
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', this.bloquearNavegacion);	
  },
  beforeUnmount() {
    if (this.debounceTimerLocalidad) clearTimeout(this.debounceTimerLocalidad);
    window.removeEventListener('popstate', this.bloquearNavegacion);
  },
  methods: {
    bloquearNavegacion() {
      history.pushState(null, '', window.location.href);
    },
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },

    getData() {
      api.get(`/vwpersonas/${this.p_idPersona}`)
        .then(r => {
          this.datoPersona   = r.data
          this.searchText    = r.data.localidadNombre ?? ''
          this.localidadHint = ''
        })
        .catch(err => console.error('Error al obtener datos de la persona:', err))
    },

    onSearchLocalidad() {
      if (this.debounceTimerLocalidad) clearTimeout(this.debounceTimerLocalidad)
      this.searchText              = this.searchText.toUpperCase()
      this.datoPersona.idLocalidad = null
      this.localidadHint           = ''
      if (this.searchText.length < 2) {
        this.filteredLocalidades = []
        return
      }
      this.debounceTimerLocalidad = setTimeout(() => this.buscarLocalidades(), 350)
    },
    async buscarLocalidades() {
      this.buscandoLocalidad = true
      try {
        const { data } = await api.get(`/vwlocalidads/buscar/${this.searchText}`)
        this.filteredLocalidades = data.slice(0, 20)
      } catch {
        this.filteredLocalidades = []
      } finally {
        this.buscandoLocalidad = false
      }
    },
    contexto(nombreJerarquico) {
      const partes = nombreJerarquico.split(' -> ')
      return partes.slice(1, -1).join(' › ')
    },
    selectLocalidad(loc) {
      this.searchText               = loc.nombre
      this.localidadHint            = loc.nombreJerarquico
      this.datoPersona.idLocalidad  = loc.idLocalidad
      this.filteredLocalidades      = []
      this.mostrarDropdownLocalidad = false
    },
    ocultarDropdownLocalidad() {
      setTimeout(() => { this.mostrarDropdownLocalidad = false }, 200)
    },

    async guardarPersona() {
      this.datoPersona.estado = 1
      if (!validarPersona(this.datoPersona)) return
      try {
        this.datoPersona.idEmpresa = window.sessionStorage.getItem('idEmpresa')
        const { data } = await api.post('/personas', this.datoPersona)
        this.datoPersona.idPersona = data.idPersona
      } catch (error) {
        if (error.response)      alertaError(error.response.data.message || 'Error desconocido al guardar la persona')
        else if (error.request)  alertaError('No se recibió respuesta del servidor.')
        else                     alertaError(error.message)
        return
      }
      window.sessionStorage.setItem('tipoIngreso', this.tipoIngreso)
      this.$router.push({
        name: 'PacienteCita02',
        state: {
          idPersona:     this.datoPersona.idPersona,
          idEspecialidad: 0,
          idMedico:       0,
          anterior:       true,
        }
      });
    },

    async consultarRC() {
      if (!this.datoPersona.documento?.trim()) {
        alertaError('Ingrese el número de documento para realizar la consulta.')
        return
      }
      try {
        const { data } = await api.get('/vwpersonas/documento', {
          params: {
            documento: this.datoPersona.documento.trim(),
            idempresa: window.sessionStorage.getItem('idEmpresa'),
          },
        })
        const persona = Array.isArray(data) ? data[0] : data
        if (persona) {
          this.datoPersona   = { ...persona }
          this.searchText    = persona.localidadNombre ?? ''
          this.localidadHint = ''
          if (persona.fechaNac) this.datoPersona.fechaNac = persona.fechaNac.slice(0, 10)
        } else {
          this.asignarDatosEstaticos()
        }
      } catch {
        this.asignarDatosEstaticos()
      }
    },
    asignarDatosEstaticos() {
      this.searchText                  = 'AZUAY'
      this.localidadHint               = ''
      this.datoPersona.idTipoIden      = 1
      this.datoPersona.idLocalidad     = 1
      this.datoPersona.idEstadoCivil   = 1
      this.datoPersona.primerNombre    = 'PRIMER NOMBRE'
      this.datoPersona.segundoNombre   = 'SEGUNDO NOMBRE'
      this.datoPersona.primerApellido  = 'PRIMER APELLIDO'
      this.datoPersona.segundoApellido = 'SEGUNDO APELLIDO'
      this.datoPersona.fechaNac        = '2024-05-23'
      this.datoPersona.direccion       = 'DIRECCION'
      this.datoPersona.telefono        = '1234567890'
      this.datoPersona.tipoPersona     = 'N'
      this.datoPersona.sexo            = 'M'
      this.datoPersona.email           = 'paciente001@correo.com'
      this.datoPersona.estado          = 1
    },

    fetchTiposIden()    { api.get('/vwtipoidens').then(r     => { this.tiposIden      = r.data }) },
    fetchEstadosCiviles(){ api.get('/vwestadocivils').then(r => { this.estadosCiviles = r.data }) },
    fetchTiposSangre()  { api.get('/vwtiposangres').then(r   => { this.tiposSangre    = r.data }) },
  },
}
</script>

<style scoped>
.wizard-wrapper {
  border: 1px solid #dee2e6; border-radius: 8px;
  overflow: hidden; background: #fff;
  max-width: 1140px; margin: 0 auto;
}
.wizard-body   { padding: 1.5rem; background: #f8f9fa; }
.wizard-footer {
  padding: 1rem 1.5rem; border-top: 1px solid #dee2e6;
  background: #fff; display: flex; justify-content: flex-end;
}
.localidad-dropdown {
  position: absolute; z-index: 1050; width: 100%;
  max-height: 260px; overflow-y: auto;
  background: #fff; border: 1px solid #ced4da;
  border-top: none; border-radius: 0 0 6px 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,.1);
  list-style: none; margin: 0; padding: 0;
}
.localidad-option {
  display: flex; flex-direction: column;
  padding: 8px 12px; cursor: pointer;
  border-bottom: 1px solid #f0f0f0; transition: background 0.1s;
}
.localidad-option:hover  { background: #e8f0fe; }
.loc-nombre              { font-size: 13px; font-weight: 500; color: #212529; }
.loc-contexto            { font-size: 11px; color: #6c757d; margin-top: 1px; }
.localidad-sin-resultado { padding: 10px 12px; font-size: 0.85rem; color: #6c757d; }
</style>